module.exports = __webpack_public_path__ + "img/pr-50.29d9dae8.png";